import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import CanadaFooter from "../../Components/Footer";
import CanadaHeader1 from "../../Components/seperate Components/CanadaHeader1";
import { Helmet } from "react-helmet";

const CanadaMicroService = () => {
  return (
    <div>
      <Helmet>
        <title>Micro Services in USA</title>
        <meta
          name="description"
          content="Explore Zithas Technologies Micro Services. Streamline operations, enhance performance, and scale efficiently with our cutting-edge solutions."
        />
      </Helmet>
      <CanadaHeader1 />

      {/* First Section */}
      <div
        className="bd-page-title-area bd-page-title-bg2 pt-220 pb-155"
        style={{ height: "380px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="bd-page-title text-center z-index"
                style={{ bottom: "45px" }}
              >
                <h2 className="breadcrumb-title" style={{ fontSize: "50px" }}>
                  Explore The Power of Micro Services
                </h2>
                <div className="breadcrumb-menu">
                  <nav className="breadcrumb-trail breadcrumbs">
                    <p style={{ color: "black" }}>
                      Trustworthy Destination for Marketing and Graphic Design
                      Services
                    </p>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* second Section */}

      <section className="bd-service-area pb-80 pt-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 pt-20">
              <div className="bd-section-title-wrapper micro_respon mb-50">
                <h2 className="bd-section-title micro-service-tittle">
                  Optimize Your Business with
                  <span style={{ color: "#ffbf1e" }}> MICRO Services</span>
                </h2>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/v1659617689/website/icons/graphic-design_qtdwyx.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Graphic Services</a>
                </h4>
                <p>
                  Enhance Your Visual Identity with Our Graphic Design Services,
                  Including Brochures, Business Cards, Logos, and More
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440676/website/icons/video-64_npwx9k.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Co-Operate Videos</a>
                </h4>
                <p>
                  Elevate Your Brand with Co-Operate Videos Featuring Product
                  Demos and Client Testimonials
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440676/website/icons/content-64_ee1slf.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Content Writing</a>
                </h4>
                <p>
                  Unlock the Power of Compelling Content to Connect with Your
                  Target Audience and Drive Conversions.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440676/website/icons/lead-64_rikrsj.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Lead Generation</a>
                </h4>
                <p>
                  Tailored Lead Generation Services to Acquire New Leads or
                  Evaluate Existing Ones.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="bd-service mb-30"
                style={{ backgroundColor: "var(--clr-bg-gray)" }}
              >
                <div className="bd-service-icon mb-20">
                  <i>
                    <img src="https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659440676/website/icons/recruitment-64_ptz66r.png" />
                  </i>
                </div>
                <h4 className="bd-service-title mb-20">
                  <a>Data management</a>
                </h4>
                <p>
                  Empower Your Business with Robust Data Management for Optimal
                  Results.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section
        className="bd-video-area pt-135 pb-130"
        style={{ backgroundColor: "#5c0385" }}
      >
        <div className="container" style={{ maxWidth: "1270px" }}>
          <div className="row responsive-banner">
            <div className="col-lg-12 first_section">
              <div className="bd-video-text">
                <h2 className="bd-video-title first-para-resp">
                  Looking for Micro Service Experts in USA?
                </h2>
                <p className="contact_section second-para-resp">
                  You're here at the right moment.
                </p>
                <p className="contact_subtext">
                  Outstanding Micro Service, Let's kick start now!
                </p>
              </div>
            </div>
            <div className="col-lg-12 second_section">
              <div className="contact-stuff pt-30">
                <div className="contact_icon icon_respon pt-15 pl-50">
                  <FontAwesomeIcon
                    icon={faPhone}
                    style={{ fontSize: "30px" }}
                  />
                </div>
                <div className="contact_txt ">
                  <p className="contact-sub-text">CALL US NOW</p>
                  <a
                    href="tel:+1 (307) 677-8060"
                    style={{ fontSize: "17px" }}
                    className="mbb-5 pb-20"
                  >
                    +1 (307) 677-8060
                  </a>
                </div>
              </div>
              {/* <Link to={"/contact-us"} onClick={toggleContact}>
                    <button className="touch-btn1 mt-20">Get Started</button>
                    </Link> */}
            </div>
          </div>
        </div>
      </section>

      <CanadaFooter />
    </div>
  );
};

export default CanadaMicroService;
